import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import cs from "classnames";
import styles from "./style/index.module.less";

function Footer(props = {}) {
  const {
    className,
    ...restProps
  } = props;
  return /*#__PURE__*/React.createElement(_Layout.Footer, _extends({
    className: cs(styles.footer, className)
  }, restProps), "\u540E\u53F0\u7BA1\u7406\u7CFB\u7EDF \xA92026 Created by Arco");
}

export default Footer;